export default __webpack_public_path__ + "static/media/next.4d9a7a46.svg";